import { createMuiTheme } from '@material-ui/core/styles';
import { WHITE, DARK_GRAY, GRAY, LIGHT_GRAY, SUCCESS_GREEN, BLACK, PRIMARY } from 'constants/colors';
const theme = createMuiTheme({
  palette: {
    primary: {
      main: PRIMARY,
      contrastText: BLACK
    },
    secondary: {
      main: DARK_GRAY,
      light: GRAY,
      contrastText: WHITE
    }
  },
  typography: {
    fontFamily: ['Calibri Light', 'Roboto'].join(','),
    fontWeightBold: 500
  },
  spacing: 8,
  overrides: {
    MuiFormLabel: {
      root: {
        '&$filled': {
          backgroundColor: LIGHT_GRAY
        },
        '&$shrink': {
          backgroundColor: LIGHT_GRAY
        }
      }
    },
    MuiAccordion: {
      root: {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        '&:not(:last-child)': {
          borderBottom: 0
        },
        '&:before': {
          display: 'none'
        },
        '&$expanded': {
          margin: 'auto'
        }
      },
      expanded: {}
    },
    MuiAccordionSummary: {
      root: {
        padding: 0,
        backgroundColor: 'transparent',
        borderBottom: '1px solid rgba(0, 0, 0)',
        minHeight: 56,
        '&$expanded': {
          minHeight: 56
        }
      },
      content: {
        '&$expanded': {
          margin: '12px 0'
        }
      },
      expanded: {},
      expandIcon: {
        padding: 0
      }
    },
    MuiAccordionDetails: {
      root: {
        margin: '8px 0 0',
        padding: '8px 0 32px'
      }
    },
    MuiDrawer: {
      paper: {
        backgroundColor: PRIMARY,
        color: BLACK
      }
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: SUCCESS_GREEN
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: SUCCESS_GREEN
        }
      }
    },
    MuiButton: {
      outlinedPrimary: {
        borderWidth: '1px'
      },
      outlined: {
        minHeight: '40px',
        borderWidth: '1px'
      },
      contained: {
        minHeight: '40px',
        backgroundColor: BLACK,
        '&:hover': {
          '@media (hover:none)': {
            background: BLACK
          }
        }
      },
      root: {
        lineHeight: 'normal',
        minWidth: '32px'
      }
    },
    MuiCssBaseline: {
      '@global': {
        strong: {
          fontWeight: 700
        },
        b: {
          fontWeight: 700
        }
      }
    }
  }
});
export default createMuiTheme({
  overrides: {
    MuiTypography: {
      // LargeHeader
      h1: {
        fontSize: '3.5rem',
        [theme.breakpoints.down('sm')]: {
          fontSize: '3rem'
        }
      },
      // Header
      h2: {
        fontSize: '2.5rem',
        [theme.breakpoints.down('sm')]: {
          fontSize: '2rem'
        }
      },
      // Title
      h3: {
        fontSize: '1.5rem',
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.25rem'
        }
      },
      // BoldSubtitle and Subtitle
      subtitle1: {
        fontSize: '1.175rem'
      },
      // Info
      body1: {}
    },
    MuiDialogContent: {
      root: {
        [theme.breakpoints.down('xs')]: {
          width: '100%'
        }
      }
    }
  }
}, theme);